import React from 'react';

import { Icon } from '@shared/ui';

import cls from './EmployeeAvatar.module.css';

interface IEmployeeAvatar {
    avatar: string | null;
}

export const EmployeeAvatar = ({ avatar }: IEmployeeAvatar) => (
    <div className={cls.avatar}>
        {avatar ? (
            <img className={cls.EmployerAvatar} src={avatar} alt="avatar" />
        ) : (
            <Icon iconName="profileBigSize" width={50} height={50} />
        )}
    </div>
);
